import { Link, useLocation } from "react-router-dom";

interface NavItemProps {
  name: string;
  link: string;
}

export const NavLink = ({ link, name }: NavItemProps) => {
  const pathname = useLocation().pathname;

  return (
    <Link to={link}>
      <div
        className={`w-fit text-sub_main ${
          pathname.includes(link)
            ? " p-0  text-[18px] md:text-[15px] ml-5 md:ml-0 "
            : ""
        }`}
      >
        {name}
        {pathname.includes(link) && (
          <div className=" border-[1px] border-white w-[50%] mx-auto relative top-1 "></div>
        )}
      </div>
    </Link>
  );
};
